import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationExtras, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable, ReplaySubject, Subject, throwError, timer } from 'rxjs';
import { ICommInterface } from 'src/app/types/comm-interface.js';
import { $b } from '../../../libs/browser_utils.js';
import { livechat, messenger } from '../../../libs/livechat_ref.js';
import { AppdataService } from '../app-data/appdata.service';
import { MessengerService } from '../messenger/messenger.service';
import { LiveChat2Wrapper } from '../../../assets/api/livechat2.wrapper.js';
import { Livechat2Api } from '../../../assets/api/livechat2api.js';
import { Logger as logger } from '../../../assets/api/logger.js';
import { v4 as uuidv4 } from 'uuid';
import { LivechatAVLibrarySettings } from 'src/libs/livechat_ref.js';


//declare const tells TypeScript that this variable exists globally 
//and is defined somewhere else (in index.html).
declare const overridePath: string; 
declare var uiLoggerSdk: any;
@Injectable({
  providedIn: 'root'
})
export class CommunicationInterfaceService {
  // configUrl = '../../../assets/app-config.json';
  configLoaded = false;
  public appConfig;
  public interactionID: any;
  public command = {};
  public startCommandObj = {};
  public messenger = messenger;
  encryptKey = 'ThisIsTheSecret';
  private livechatRef: ICommInterface;
  ucid: string = $b.GetQueryString('ucid');
  intent: string = $b.GetQueryString('intent');
  sessionId: string;
  chosenCameraDevice: any;
  canProceed: boolean = false;

  private callbacks = new ReplaySubject<any>();
  private livechatCallback = new Subject<any>();
  private sessionToken = new Subject<any>();
  private chatBotMsg = new Subject<any>();
  private permissions = new ReplaySubject<any>(20);
  livechatConferenceAgentEvent = new Subject<any>();
  customerMessage = new Subject<any>();
  inQueue = new Subject<any>();
  endOfSession = new ReplaySubject<any>();
  parallelCameraUsage = new Subject<boolean>();

  callbacksObservable: Observable<any> = this.callbacks.asObservable();
  sessionTokenObservable: Observable<any> = this.sessionToken.asObservable();
  chatBotReceivedMessage: Observable<any> = this.chatBotMsg.asObservable();
  livechatCallbackObservable: Observable<any> = this.livechatCallback.asObservable();
  permissionsObservable: Observable<any> = this.permissions.asObservable();
  customerMessageObservable: Observable<any> = this.customerMessage.asObservable();
  inQueueObservable: Observable<any> = this.inQueue.asObservable();
  parallelCameraUsageObservable: Observable<any> = this.parallelCameraUsage.asObservable();
  endOfSessionObservable: Observable<any> = this.endOfSession.asObservable();
  livechatConferenceAgentEventObservable: Observable<any> = this.livechatConferenceAgentEvent.asObservable();
  snackbarHorizontalPosition: any;
  snackbarVerticalPosition: any;
  public availableInputDevices = {
    audio: [],
    video: []
  };

  public audio = new Audio();

  public devicePermissions = {
    audio: false,
    video: false,
    location: false,
    webrtc: false,
    screenshare: false
  };
  public timeLeft: number = 100;
  interval;
  subscribeTimer: any;
  appLabels: any;
  connectionTimeout: any;
  connectionTimeoutTimeLeft: number;
  isCaptchaEnabledFromBackend = undefined;

  constructor(
    private snackBar: MatSnackBar,
    private route: Router,
    public zone: NgZone,
    private appDataService: AppdataService,
    private messengerService: MessengerService
  ) {
    this.snackbarHorizontalPosition = 'center';
    this.snackbarVerticalPosition = 'top';

    console.log('%c CommunicationInterfaceService', 'color:white; background: blue;');

    appDataService.appConfigSub.subscribe((config) => {
      if (!config) {
        return;
      }
      this.appConfig = config;
      this.appLabels = this.appDataService.getLabels();
      this.snackbarHorizontalPosition = this.appConfig?.Miscellaneous?.snackbarPosition?.horizontalPosition || 'center';
      this.snackbarVerticalPosition = this.appConfig?.Miscellaneous?.snackbarPosition?.verticalPosition || 'top';
    LivechatAVLibrarySettings.LiveChatAvEnableReporting = this.appConfig.Miscellaneous?.enableAVReporting ?? false;
      
    const chatmode = this.appConfig?.channelConfiguration?.chatmode;
    const channelName = this.appLabels?.liveChatComponent?.ChannelLabels[chatmode];
    this.startCommandObj = {
        pIntent: this.intent,
        pUcid: this.ucid,
        pChannel: channelName,
        pChatBotSid: uuidv4(),
        pUserId: null,
        agentid: null,
        interactionid: null,
        node: null,
        mobile: null
      };

      window.addEventListener('message', this.receivedChatbotMsg, false);
      const configs = {
        url: this.appConfig.CommunicationInterface.livechat2.url,
        captchaServiceUrl: this.appConfig.CommunicationInterface.livechat2.captchaServiceUrl,
        name: this.appConfig.BuildFor,
        address: "PC",
        pIntent: this.intent,
        authType: "external",
        pChatBotSid: uuidv4(),        
        routepath: this.appConfig.routepath,
        channel: channelName,
        chatmode: this.appConfig.channelConfiguration.chatmode,
      }

      this.livechatRef = this.appConfig.CommunicationInterface?.activeLiveChat.toLowerCase() == "livechat2" 
        ? new LiveChat2Wrapper(
            configs
          , Livechat2Api, logger)
        : livechat;
      this.messengerService.LivechatStatus = this.appConfig.CommunicationInterface?.activeLiveChat;
      console.log('%c Active LiveChat - ' + this.appConfig.CommunicationInterface?.activeLiveChat, 'color:black; background: dodgerblue;font-size: 15px;');


    });
  }

  open = () => {
    try {
      this.livechatRef.Open();
      this.resetTimer();
      this.startTimer();
      this.logToServer('info', 'CommunicationInterfaceService.open', `Livechat Open Triggered`);
    } catch (error) {
      console.error('%c Communication Interface - Open : ', 'color:white; background: #FF5722;', error);
      this.noInternetConnection();
    }
  };

  start = (custInfo: any, []) => {
    try {
      console.log("*********Start Object: ", custInfo);
      this.livechatRef.Start(custInfo, []);
      this.logToServer('info', 'CommunicationInterfaceService.start', `Livechat Start Triggered`);
      return true;
    } catch (error) {
      console.error('%c Communication Interface - Start : ', 'color:white; background: #FF5722;', error);
      this.sendUIErrors('CommunicationInterfaceService', 'start', error);
    }
  };

  setCaptcha = (elementIdRef: any) => {
    try {
        this.livechatRef.setCaptchaImage(elementIdRef);
    } catch (error) {
      console.error('%c Communication Interface - setCaptcha : ', 'color:white; background: #FF5722;', error);
    }
  };

  resetCaptcha = (elementIdRef: any) => {
    try {
      this.livechatRef.resetCaptchaImage(elementIdRef);
      this.resetTimer();
      this.startTimer();
      this.logToServer('info', 'CommunicationInterfaceService.resetCaptcha', `Livechat resetCaptchaImage Triggered`);
    } catch (error) {
      console.error('%c Communication Interface - resetCaptcha : ', 'color:white; background: #FF5722;', error);
    }
  };

  accessToken = () => {
    try {
      this.livechatRef.GetAccessToken(
        (token: string) => {
          this.sessionToken.next({ successMsg: token });
        },
        (error: string) => {
          this.sessionToken.next({ errorMsg: error });
        }
      );
      this.logToServer('info', 'CommunicationInterfaceService.accessToken', `Livechat GetAccessToken Triggered`);
    } catch (error) {
      console.error('%c Communication Interface - accessToken : ', 'color:white; background: #FF5722;', error);
    }
  };

  isCaptchaEnabledStatus = () => {
    try {
      this.logToServer('info', 'CommunicationInterfaceService', 'isCaptchaEnabledStatus');
      if(this.livechatRef.isCaptchaEnabled) {
        this.livechatRef.isCaptchaEnabled((success: any) => {
          this.isCaptchaEnabledFromBackend = success;           
          console.log("isCaptchaEnabledFromBackend success", this.isCaptchaEnabledFromBackend)  
          this.callbacks.next({ callbackName: 'CaptchaEnabledStatus', params: success });     
          return success;
        },
        (error: any) => {
          this.isCaptchaEnabledFromBackend = error;   
          console.log("isCaptchaEnabledFromBackend error", this.isCaptchaEnabledFromBackend)
          this.callbacks.next({ callbackName: 'CaptchaEnabledStatus', params: error });
          return error;
        });
      } else {
        this.isCaptchaEnabledFromBackend = this.appConfig.isCaptchaEnabled; 
        console.log("isCaptchaEnabledFromBackend undefined", this.isCaptchaEnabledFromBackend)
        this.callbacks.next({ callbackName: 'CaptchaEnabledStatus', params: this.isCaptchaEnabledFromBackend });

      }

    } catch (error) {
      console.error('%c Communication Interface - isCaptchaEnabledStatus : ', 'color:white; background: #FF5722;', error);
    }
  };

  receivedChatbotMsg = (msg?: any) => {
    try {
      this.livechatRef.OnMessageReceived = (agent: string, message: string, id: string) => {
        this.callbacks.next({ callbackName: 'MessageReceived', params: { agent, message, id } });
      };
    } catch (error) {
      console.error('%c Communication Interface - receivedChatbotMsg : ', 'color:white; background: #FF5722;', error);
      this.sendUIErrors('CommunicationInterfaceService', 'receivedChatbotMsg', error);
    }
  };

  end = (reason?: string, interactionID?: any) => {
    try {
      console.log('Ending Livechat', reason, interactionID);
      this.livechatRef.End(reason);
    } catch (error) {
      console.error('%c Communication Interface - End : ', 'color:white; background: #FF5722;', error);
    }
  };

  sendMessage = (msg?: any, command?: any, data?: any, interactionID?: any) => {
    try {
      console.log('Sending Message', msg);
      this.livechatRef.SendMessage(msg, null);
      this.resetConnectionTimeoutTimer();
      this.startConnectionTimeoutTimer();
      this.logToServer('info', 'CommunicationInterfaceService', `sendMessage: ${msg.length}`);
    } catch (error) {
      console.error('%c Communication Interface - SendMessage : ', 'color:white; background: #FF5722;', error);
      this.sendUIErrors('CommunicationInterfaceService', 'sendMessage', error);
    }
  };

  /**
   * check Server Connection every serverConnectionTimeoutMessage seconds
   */
  checkServerConnection = () => {
    if (this.messengerService.isLiveAgentConnected) {
      return;
    }
    this.snackBar.open(
      this.appLabels?.globalLabels?.serverConnectionTimeoutMessage ?? `Lost connection to server`,
      'Dismiss',
      {
        duration: 5000,
        horizontalPosition: this.snackbarHorizontalPosition,
        verticalPosition: this.snackbarVerticalPosition,
        panelClass: ['custom-snackbar']
      }
    );
  };

  sendAppMessage = (msg: any) => {
    try {
      this.livechatRef.SendAppMessage(msg);
    } catch (error) {
      console.error('%c Communication Interface - SendAppMessage : ', 'color:white; background: #FF5722;', error);
    }
  };

  checkDeviceSupport = () => {
    try {
      this.livechatRef.CheckDeviceSupport().then((x) => {
        delete x.MediaDevices;
        this.devicePermissions.webrtc = x.isWebRTCSupported;
        this.devicePermissions.screenshare = x.isScreenshareSupported;
        $b.SetLocalStorage('deviceSupport', JSON.stringify(x));
      });
    } catch (error) {
      console.error('%c Communication Interface - checkDeviceSupport : ', 'color:white; background: #FF5722;', error);
    }
  };

  checkCameraParallelUsageStatus(status) {
    switch (status) {
      case 'permission':
        this.parallelCameraUsage.next(false);
        break;
      case 'parallel usage':
        this.parallelCameraUsage.next(true);
        break;
      default:
        return;
    }
  }

  getCameraParallelUsageStatus(commInterfaceService) {
    console.error = function (txt, args) {
      if (args?.toString().includes('NotAllowedError')) {
        commInterfaceService.checkCameraParallelUsageStatus('permission');
      } else if (args?.toString().includes('NotReadableError')) {
        commInterfaceService.checkCameraParallelUsageStatus('parallel usage');
      }
    };

    try{
      this.appDataService.getUserMediaFn({video: true})
      .then((stream) => {
        stream.getTracks().forEach((track) => {
          this.parallelCameraUsage.next(false);
          track.stop();
        });
      });
    } catch (e) {
      this.logToServer(
        'info',
        'CommunicationInterface.getCameraParallelUsageStatus',
        `Error - ${JSON.stringify(e.toString())}`
      );
      console.error(e);
    }
  }

  getAudioVideoInputs = () => {
    if(!this.appDataService.getUserMediaFn) {
      this.permissions.next({proceedText: 'Proceed to Chat',type: 'video',status: false});
      this.permissions.next({proceedText: 'Proceed to Chat',type: 'audio',status: false});
      this.snackBar.open(`Getting user media not supported`, 'Dismiss', {
        duration: 3000,
        horizontalPosition: this.snackbarHorizontalPosition,
        verticalPosition: this.snackbarVerticalPosition,
        panelClass: ['custom-snackbar']
      });
      return;
    }
    /**
     * based on the configuration 'combinedMediaPermission'
     * media devices are to be captured
     */

    if(this.appConfig?.permissionsConfig?.combinedMediaPermission) {
      this.appDataService.getUserMediaFn({ audio: true, video: true})
      .then((stream) => {
        this.logToServer(
          'info',
          'CommunicationInterface.getAudioVideoInputs',
          `Cmb Track Info - ${JSON.stringify(stream.getTracks())}`
        );
        this.permissions.next({proceedText: 'Proceed',type: 'video',status: true});

        this.livechatRef.CheckDeviceSupport().then((deviceInfo) => {
          deviceInfo.MediaDevices.forEach((device: any, i: number) => {
            this.logToServer(
              'info',
              'CommunicationInterface.getAudioVideoInputs',
              `Cmb Device Info [${i}] - ${JSON.stringify({kind: device?.kind, label: device?.label})}`
            );
            if (device.kind === 'audioinput') {
              this.upsert(this.availableInputDevices.audio, device);
            }
            if (device.kind === 'videoinput') {
              this.upsert(this.availableInputDevices.video, device);
            }
          });
        });
        stream.getTracks().forEach((track) => {        
          this.devicePermissions.audio = true;     
          this.devicePermissions.video = true;     
          track.stop();
        });       
      })
      .catch((err) => {
        this.logToServer(
          'info',
          'CommunicationInterface.getAudioVideoInputs',
          `Cmb Error - ${JSON.stringify(err.toString())}`
        );
        this.permissions.next({proceedText:'Proceed to Chat',type: 'audio',status: false});
        this.snackBar.open(`Media access denied`, 'Dismiss', {
          duration: 3000,
          horizontalPosition: this.snackbarHorizontalPosition,
          verticalPosition: this.snackbarVerticalPosition,
          panelClass: ['custom-snackbar']
        });
      });
    } else {
      // checking for microphone availability
      this.appDataService.getUserMediaFn({ audio: true})
      .then((stream) => {
        this.logToServer(
          'info',
          'CommunicationInterface.getAudioVideoInputs',
          `Audio Track Info - ${JSON.stringify(stream.getTracks())}`
        );
        this.livechatRef.CheckDeviceSupport().then((deviceInfo) => {
          deviceInfo.MediaDevices.forEach((device: any, i: number) => {
            this.logToServer(
              'info',
              'CommunicationInterface.getAudioVideoInputs',
              `Audio Device Info [${i}] - ${JSON.stringify({kind: device?.kind, label: device?.label})}`
            );
            if (device.kind === 'audioinput') {
              this.upsert(this.availableInputDevices.audio, device);
            }
          });
        });
        stream.getTracks().forEach((track) => {        
          this.devicePermissions.audio = true;        
          track.stop();
        });
      })
      .catch((err) => {
        this.logToServer(
          'info',
          'CommunicationInterface.getAudioVideoInputs',
          `Audio Error - ${JSON.stringify(err.toString())}`
        );
        this.permissions.next({proceedText:'Proceed to Chat',type: 'audio',status: false});
        this.snackBar.open(`Microphone access denied`, 'Dismiss', {
          duration: 3000,
          horizontalPosition: this.snackbarHorizontalPosition,
          verticalPosition: this.snackbarVerticalPosition,
          panelClass: ['custom-snackbar']
        });
      });

      // checking for camera availability
      this.appDataService.getUserMediaFn({ video: true})
      .then((stream) => {
        this.logToServer(
          'info',
          'CommunicationInterface.getAudioVideoInputs',
          `Video Track Info - ${JSON.stringify(stream.getTracks())}`
        );
        this.permissions.next({proceedText: 'Proceed',type: 'video',status: true});

        this.livechatRef.CheckDeviceSupport().then((deviceInfo) => {
          deviceInfo.MediaDevices.forEach((device: any, i: number) => {
            this.logToServer(
              'info',
              'CommunicationInterface.getAudioVideoInputs',
              `Video Device Info [${i}] - ${JSON.stringify({kind: device?.kind, label: device?.label})}`
            );
            if (device.kind === 'videoinput') {
              this.upsert(this.availableInputDevices.video, device);
            }
          });
        });
        stream.getTracks().forEach((track) => {
          this.devicePermissions.video = true;        
          track.stop();
        });
      })
      .catch((err) => {
        this.logToServer(
          'info',
          'CommunicationInterface.getAudioVideoInputs',
          `Video Error - ${JSON.stringify(err.toString())}`
        );
        this.permissions.next({proceedText: 'Proceed to Chat',type: 'video',status: false});
        setTimeout(() => {
          this.snackBar.open(`Camera access denied`, 'Dismiss', {
            duration: 3000,
            horizontalPosition: this.snackbarHorizontalPosition,
            verticalPosition: this.snackbarVerticalPosition,
            panelClass: ['custom-snackbar']
          });
        }, this.availableInputDevices.audio.length === 0 ?  3000 : 500);
      });    
      console.log('%c Communication Interface - InputDevices : ', 'color:white; background: #FF5722;', this.availableInputDevices);
    }
    
    // if(!this.sessionId) {
    //   this.isCaptchaEnabledStatus();
    // }
  };

  upsert = (array, item) => {
    // (1)
    const i = array.findIndex((_item) => _item.id === item.id);
    if (i > -1) array[i] = item; // (2)
    else array.push(item);
  };

  setInputDevices = (audioId, videoId) => {
    try {
      return this.livechatRef.SetInputDevice(audioId, videoId);
    } catch (error) {}
  };

  registerCallbackEvents = () => {
    try {
      this.livechatRef.OnOpenSuccess = (session: any) => {
        // assign the session id        
        this.clearTimer();
        this.sessionId = session?.sid_tchat ?? '';
        this.callbacks.next({ callbackName: 'OpenSuccess', params: session }); // if no session found
      };
      this.livechatRef.OnOpenFailed = (retCode: string) => {
        this.callbacks.next({ callbackName: 'OpenFailed', params: retCode }); // if no session found
      };
      this.livechatRef.OnStartSuccess = (sid: string, tChatId: string, param: any) => {
        // assign the session id
        this.sessionId = tChatId;
        this.clearTimer();
        this.callbacks.next({ callbackName: 'StartSuccess', params: { sid, tChatId, param } }); // if new session start success
      };
      this.livechatRef.OnStartFailed = (code: any) => {
        this.callbacks.next({ callbackName: 'StartFailed', params: code }); // if new session start success
      };
      this.livechatRef.OnCallQueued = (queuePos: number, queueType: string) => {
        this.callbacks.next({ callbackName: 'CallQueued', params: { queuePos, queueType } });
      };
      this.livechatRef.OnRemoteUserConnected = (name: string, agentId: string, sessionID: string, extraParam: any) => {
        this.callbacks.next({ callbackName: 'RemoteUserConnected', params: { name, agentId, sessionID, extraParam } });
      };
      this.livechatRef.OnConferenceUserLeft = (agent: string, reason: string) => {
        this.callbacks.next({ callbackName: 'ConferenceUserLeft', params: { agent, reason } });
      };
      this.livechatRef.OnTypingStateChanged = (agent: string, state: number) => {
        this.callbacks.next({ callbackName: 'TypingStateChanged', params: { agent, state } });
      };
      this.livechatRef.OnUserJoining = (agent: string, reason: string) => {
        this.callbacks.next({ callbackName: 'OnUserJoining', params: { agent, reason } });
      };
      this.livechatRef.OnCallbackAutoRegistered = (reasonCode: string) => {
        this.callbacks.next({ callbackName: 'CallbackAutoRegistered', params: reasonCode });
      };
      // received in livechat component
      this.livechatRef.OnInternalServerError = (errorCode: string) => {
        this.callbacks.next({ callbackName: 'InternalServerError', params: errorCode });
      };
      this.livechatRef.OnAppMessageReceived = (agent: string, message: string, id: string) => {
        this.livechatCallback.next({ callbackName: 'AppMessageReceived', params: { agent, message, id } });
      };
      // received in livechat component
      this.livechatRef.OnServerStateChanged = () => {
        this.callbacks.next({ callbackName: 'ServerStateChanged', params: '' });
      };
      this.livechatRef.OnEcho = (message: string, id: string) => {
        this.livechatCallback.next({ callbackName: 'Echo', params: { message, id } });
      };
      this.livechatRef.OnServersideEnd = (initiator: string, reason: string) => {
        this.callbacks.next({ callbackName: 'ServersideEnd', params: { initiator, reason } });
      };
      this.livechatRef.OnClientsideEnd = (initiator: string, reason: string) => {
        this.callbacks.next({ callbackName: 'ClientsideEnd', params: { initiator, reason } });
      };
      this.livechatRef.OnEnd = (initiator: string, reason: string) => {
        this.callbacks.next({ callbackName: 'End', params: { initiator, reason } });
      };

      this.logToServer('info', 'CommunicationInterfaceService', 'registerCallbackEvents');
    } catch (error) {
      console.error(
        '%c Communication Interface - registerCallbackEvents : ',
        'color:white; background: #FF5722;',
        error
      );
    }
  };

  mediaStreamerInfo() {
    if(this.appConfig?.CommunicationInterface?.activeLiveChat == undefined) {
      // old configs has to be used as new one is not updated
      // TODO This config will be deprecated in future 
      return this.appConfig?.CommunicationInterface?.livechat1?.mediaStreamer;
    } else {
      // latest config will be used
      return this.appConfig?.CommunicationInterface?.mediaStreamer;
    }
  }

  uploadFiles = async (data: any) => {
    try {
      if (!this.appConfig.attachments || this.canUpload(data)) {
        if (this.mediaStreamerInfo().enable) {
          const response = await this.livechatRef.uploadMedia(
            data,
            this.mediaStreamerInfo().organizationId ?? 'OrgId',
            this.mediaStreamerInfo().uploader ?? 'UploadedBy'
          );
          console.log(response);
          if (response?.isSuccess && response?.result && response.result.length) {
            response.result.forEach((result) => {
              const responseParams = [
                {
                  type: 'file',
                  name: result?.originalName,
                  fileUrl: this.reformUrl(result?.downloadURL),
                  interactionID: result?.interactionID,
                  size: result?.size
                }
              ];
              this.livechatCallback.next({ callbackName: 'UploadComplete', params: JSON.stringify(responseParams) });
            });
          } else throw new Error('Non OK upload response');
        } else this.livechatRef.uploadFiles(data);
      } else {
        if (data && data[0]) {
          this.snackBar.open(
            'OOPS! Maximum File Size limit exceeded, Please Upload a File below ' +
              this.getFileSizeLimitInMB(this.appConfig.attachments.maxSizeLimit),
            'Dismiss',
            { duration: 5000 }
          );
          this.messengerService.handleProgressBar(false);
          throw new Error('Max file size exceeded');
        }
      }
    } catch (error) {
      console.error('%c Communication Interface - uploadFiles : ', 'color:white; background: #FF5722;', error);
      throw error;
    }
  };

  /**
   * if the url does't have the domain name and is a partial url
   * prepend the overridepath to the url 
   * param fileUrl: is the file url received from server
   */
  reformUrl = (fileUrl: string) => {
    var reformedUrl = fileUrl;
    if(this.appConfig?.CommunicationInterface?.activeLiveChat.toLowerCase() == "livechat1")
      {
      if (fileUrl.startsWith('/api')) {
        reformedUrl = overridePath + fileUrl.replace("/api", "");
      }
    }
    return reformedUrl;
}

  downloadUrl = (filename: any) => {
    try {
      const data = this.livechatRef.prepareDownloadURL(filename);
      return data;
    } catch (error) {
      console.error('%c Communication Interface - downloadUrl : ', 'color:white; background: #FF5722;', error);
    }
  };

  uploadComplete = () => {
    try {
      this.livechatRef.OnUploadComplete = (response: string) => {
        this.livechatCallback.next({ callbackName: 'UploadComplete', params: response });
      };
    } catch (error) {
      console.error('%c Communication Interface - uploadComplete : ', 'color:white; background: #FF5722;', error);
    }
  };

  echoMessage = () => {
    try {
      this.livechatRef.OnEcho = (message: any, id: any) => {
        this.callbacks.next({ callbackName: 'Echo', params: { message, id } });
      };
    } catch (error) {
      console.error('%c Communication Interface - echoMessage : ', 'color:white; background: #FF5722;', error);
    }
  };

  setAVConfigs = (Config: any) => {
    try {
      this.livechatRef.SetAvConfigs(Config);
    } catch (error) {
      console.error('%c Communication Interface - setAVConfigs : ', 'color:white; background: #FF5722;', error);
    }
  };

  pauseAV = (audio: any, video: any) => {
    try {
      this.livechatRef.Pause(audio, video);
    } catch (error) {
      console.error('%c Communication Interface - pauseAV : ', 'color:white; background: #FF5722;', error);
    }
  };

  startAV = (startConfig: any) => {
    try {
      this.livechatRef.StartAvCall(startConfig.sid, startConfig.uid, startConfig.callType);
    } catch (error) {
      console.error('%c Communication Interface - startAV : ', 'color:white; background: #FF5722;', error);
    }
  };

  endAV = () => {
    try {
      this.livechatRef.EndAvCall();
    } catch (error) {
      console.error('%c Communication Interface - endAV : ', 'color:white; background: #FF5722;', error);
    }
  };

  startScreenshare = (startConfig: any) => {
    try {
      this.livechatRef.StartScreensharing(startConfig.sid, startConfig.uid, startConfig);
    } catch (error) {
      console.error('%c Communication Interface - startScreenshare : ', 'color:white; background: #FF5722;', error);
    }
  };

  stopScreenshare = () => {
    try {
      this.livechatRef.StopScreensharing();
    } catch (error) {
      console.error('%c Communication Interface - startScreenshare : ', 'color:white; background: #FF5722;', error);
    }
  };

  notifyTypingChange = (state: any) => {
    try {
      this.livechatRef.NotifyTypingStateChange(state);
    } catch (error) {
      console.error('%c Communication Interface - notifyTypingChange : ', 'color:white; background: #FF5722;', error);
    }
  };
  
  noInternetConnection = () => {
    this.snackBar.open(`Network Connectivity Failed`, 'Dismiss', {
      duration: 5000,
      horizontalPosition: this.snackbarHorizontalPosition,
      verticalPosition: this.snackbarVerticalPosition,
      panelClass: ['custom-snackbar']
    });
    let currentQueryParams = Array.from(new URLSearchParams(window.location.search).keys()).reduce(
      (acc, val) => ({ ...acc, [val]: new URLSearchParams(window.location.search).get(val) }),
      {}
    );
    currentQueryParams = Object.fromEntries(Object.entries(currentQueryParams).sort());
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'preserve',
      preserveFragment: true,
      queryParams: currentQueryParams,
      state: { reload: true }
    };
    this.zone.run(() => {
      this.route.navigate(['/'], navigationExtras);
    });
  };

  decryptAppConfig = () => {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  };

  logToServer = (type: string, unit: string, message: string) => {
    try {
      this.livechatRef?.slog(type, `[VIVR.${unit}]`, `${this.sessionId ? `${this.sessionId}:` : ''} ${message}`);
      if (type == 'info') {
        this.sendUILogs(unit.split('.')[0], unit.split('.').length > 1 ? unit.split('.')[1] : unit, message);
      }
    } catch (error) {}
  };

  triggerAudio() {
    if (this.appConfig.ChatQueueComponent.enableQueueAudio) {
      this.audio.src = this.appConfig.ChatQueueComponent.queueAudio;
      this.audio.loop = true;
      this.audio.autoplay = true;
      this.audio.crossOrigin = 'anonymous';
      this.audio.volume = 0;
    }
  }

  canUpload = (files) => {
    try {
      let can = true;
      if (typeof files === 'object' && !Array.isArray(files) && files !== null) {
        Object.keys(files).forEach((index) => {
          if (files[index].size > this.appConfig.attachments.maxSizeLimit) {
            can = false;
          }
        });
      } else {
        files.forEach((file) => {
          // check for configured file size
          if (file.size > this.appConfig.attachments.maxSizeLimit) {
            can = false;
          }
          // check for configured file type can be added here
        });
      }
      return can;
    } catch (e) {
      console.log(e);
    }
  };

  getFileSizeLimitInMB = (sizeInBytes) => {
    return sizeInBytes / (1024 * 1024) + 'MB';
  };

  upgradeToVideo = (videoDeviceId: string) => {
    this.livechatRef.upgradeToVideo(videoDeviceId);
  };

  notifyEndOfSession = (initiator) => {
    this.endOfSession.next(initiator);
  };

  sendUILogs(...args) {
    uiLoggerSdk?.LogInfo(...args);
  }

  sendUIErrors(...args) {
    uiLoggerSdk?.LogError(...args);
  }

  sendUIDebug(...args) {
    uiLoggerSdk?.LogDebug(...args);
  }

  resetTimer() {
    clearInterval(this.interval);
    this.timeLeft = this.appConfig.Miscellaneous.OpenStartTimeoutDuration;
  }

  clearTimer() {
    clearInterval(this.interval);
    this.timeLeft = 0;
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 0;
        this.resetTimer();
        console.log(
          'OpenStartTimeoutDuration Timeout: ' +
            this.appConfig.Miscellaneous.OpenStartTimeoutDuration +
            'seconds after loading'
        );
        this.callbacks.next({ callbackName: 'OpenStartTimedOut', params: '' });
      }
    }, 1000);
  }

  /**
   * reset ServerConnectionTimeout timer
   */
  resetConnectionTimeoutTimer() {
    // console.log("ConnectionTimeoutTimer resetConnectionTimeoutTimer", this.connectionTimeoutTimeLeft)
    clearInterval(this.connectionTimeout);
    this.connectionTimeoutTimeLeft = this.appConfig.Miscellaneous.ServerConnectionTimeout;
  }

  /**
   * clear ServerConnectionTimeout timer
   */
  clearConnectionTimeoutTimer() {
    clearInterval(this.connectionTimeout);
    this.connectionTimeoutTimeLeft = 0;
  }

  /**
   * start ServerConnectionTimeout timer
   */
  startConnectionTimeoutTimer() {
    if (this.messengerService.isLiveAgentConnected) {
      return;
    }
    this.connectionTimeout = setInterval(() => {
      if (this.connectionTimeoutTimeLeft > 0) {
        this.connectionTimeoutTimeLeft--;
      } else {
        this.connectionTimeoutTimeLeft = 0;
        this.resetConnectionTimeoutTimer();
        this.checkServerConnection();
      }
    }, 1000);
  }
}
